import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@src/shared/components/ui/tabs";

import { ExtractedCareGapsTab } from "./components/ExtractedCareGapsTab";
import { UnmatchedPatientUploadsList } from "./components/UnmatchedPatientUploadsList";

export function CareProtocolOpportunityHistoryListV2() {
  return (
    <Tabs defaultValue="extracted" className="w-full">
      <TabsList className="mb-4 grid w-full grid-cols-2">
        <TabsTrigger value="extracted">Extracted care gaps</TabsTrigger>
        <TabsTrigger value="unmatched">Unmatched documents</TabsTrigger>
      </TabsList>
      <TabsContent value="extracted" className="mt-0">
        <ExtractedCareGapsTab />
      </TabsContent>
      <TabsContent value="unmatched" className="mt-0">
        <UnmatchedPatientUploadsList />
      </TabsContent>
    </Tabs>
  );
}
